import React, { useEffect, useState, useContext } from "react";
import Layout from "../../components/layout/Layout";
import HomeHeroSection from "../../components/heroSection/homeHeroSection";
import AboutUsExtra from "../../components/aboutUsExtra";
import Products from "../../components/ourProducts";
import Button from "../../components/common/button";
import Video from "../../components/Video";
import OurTeam from "../../components/ourTeam";
import WhyUs from "../../components/whyUs";
import { Link } from "react-router-dom";
import SplashScreen from "../../components/splashScreen";
import { LanguageContext } from "../../context/LanguageContext";
function Home() {
  const { data } = useContext(LanguageContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  });
  if (loading) {
    return <SplashScreen />;
  }
  return (
    <Layout>
      <Video />
      <div className="contentWrapper">
        <HomeHeroSection
          title={data.aboutUs.title}
          subtitle={data.aboutUs.subtitle}
          heroImage={data.aboutUs.img}
          p1={data.supplierContent.p1}
          p2={data.supplierContent.p2}
        />
        <AboutUsExtra
          heroImage={data.aboutUs.aboutUsExtra.gif}
          p1={data.aboutUs.aboutUsExtra.p1}
          gifSubtitle={data.aboutUs.aboutUsExtra.subTitle}
          qualityWord={data.aboutUs.aboutUsExtra.qualityWords.map(
            (item) => item
          )}
          mission={data.aboutUs.aboutUsExtra.mission}
        />
      </div>
      <div className="">
        <Products
          products={data.ourProducts.map((products) => products).slice(0, 6)}
        />
        <Link to="/ourProducts">
          <Button name="View All" />
        </Link>
      </div>

      <div className="contentWrapper">
        <WhyUs
          title={data.whyUs.title}
          subtitle={data.whyUs.subtite}
          content={data.whyUs.content.map((item) => item)}
          img={data.whyUs.img}
        />
      </div>
      <div className="contentWrapper">
        <OurTeam />
      </div>
    </Layout>
  );
}

export default Home;
